<template>

  <div class="term" >
    <div class="title-term" v-html="title"></div>
    <div class="output-term" v-html="output"></div>
  </div>

</template>

<script>

export default {
  name: "Preview",
  props:{
    error:String,
    output:String,
  },
  data () {
    return {
      tempo:'',
      title:'Bienvenido Kichwa Code'
    }
  },
  methods: {

  },
  components: {

  },
};

</script>
<style>
.term{
  margin-top: 30px;
  height: 100%;
  background: #030924;

}
.title-term{
  text-align: center;
  font-size: 1.3rem;
  color:white;
}
.output-term{
  margin-top: 10px;
  font-size: 1rem;
  margin-left: 20px;
  color: green;
}
.error-term{
  margin-top: 10px;
  font-size: 1rem;
  margin-left: 20px;
  color: red;
}
</style>
